module.exports = __webpack_public_path__ + "static/media/content-1.c60b0c81.png";